export const FormElements = {
    reason: {
        name: "reason",
        placeholder: "Rejected Reason",
        isMandatory: true
    }
};